import { useRealAmap, userPolyLinePlugin, Layer } from '@ow/maps/lib'
import { useProjectStore, useTbViewStore } from '@vt/hooks'
import { useRef } from 'react'
// import { mergeQueries } from '@ow/utils'

const useVtAmap = (mapId) => {
  const getVtProject = useProjectStore((state) => state.getVtProject)
  const { amapKey = '0e4f7b5e424e7db93755cb5d48e71a75' } = getVtProject()

  const { ditto, mapConfig } = useTbViewStore(['ditto', 'filters', 'mapConfig'])

  const polylinesLayer = useRef(new Layer(ditto, {}))
  const usersLayer = useRef(new Layer(ditto, {}))

  const amapState = useRealAmap(
    mapId,
    {
      amapKey,
      plugins: [userPolyLinePlugin()],
      zoom: mapConfig?.zoom,
      center: mapConfig?.center,
    },
    ({ getApis }) => {
      const { initUserPolyline } = getApis()
      initUserPolyline(polylinesLayer.current, usersLayer.current)
    }
  )

  const { inited } = amapState

  return { amapState, polylinesLayer, usersLayer, inited }
}

export default useVtAmap
